import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Insanction(state = initialState, action) {
  switch (action.type) {
    case userConstants.INSANCTION_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.INSANCTION_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.INSANCTION_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}